import { useCallback, useState } from 'react';
import { clearSelectedIds, toggleSelectedId } from './recipeFilters.helpers';

interface UseRecipeFiltersResult {
  selectedTagIds: number[];
  selectedAuthorIds: number[];
  sortField: string;
  sortDirection: 'asc' | 'desc';
  handleTagChange: (tagId: number, isChecked: boolean) => void;
  handleAuthorChange: (authorId: number, isChecked: boolean) => void;
  clearFilters: () => void;
  setSortField: React.Dispatch<React.SetStateAction<string>>;
  setSortDirection: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>;
}

export const useRecipeFilters = (
  initialSortField: string,
  initialSortDirection: 'asc' | 'desc'
): UseRecipeFiltersResult => {
  const [selectedTagIds, setSelectedTagIds] = useState<number[]>([]);
  const [selectedAuthorIds, setSelectedAuthorIds] = useState<number[]>([]);
  const [sortField, setSortField] = useState<string>(initialSortField);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>(initialSortDirection);

  const handleTagChange = useCallback((tagId: number, isChecked: boolean) => {
    setSelectedTagIds((previous) => toggleSelectedId(previous, tagId, isChecked));
  }, []);

  const handleAuthorChange = useCallback((authorId: number, isChecked: boolean) => {
    setSelectedAuthorIds((previous) => toggleSelectedId(previous, authorId, isChecked));
  }, []);

  const clearFilters = useCallback(() => {
    setSelectedTagIds(clearSelectedIds);
    setSelectedAuthorIds(clearSelectedIds);
  }, []);

  return {
    selectedTagIds,
    selectedAuthorIds,
    sortField,
    sortDirection,
    handleTagChange,
    handleAuthorChange,
    clearFilters,
    setSortField,
    setSortDirection,
  };
};

export default useRecipeFilters;
